<label>{{ label }}</label>
<ng-select
  class="channel-box"
  [items]="options?.options"
  bindValue="value"
  bindLabel="label"
  [(ngModel)]="value"
  (change)="onChange()"
  [multiple]="options.multi"
>
</ng-select>
